<template>
  <!--
  ==========================================================================
  General
  ==========================================================================
  -->
  <form class="h-100 scrollable padded">
    <div>
      <h3>Stato</h3>
      <p>
        Lo stato della richiesta è
        <strong :class="'text-' + variantFor(value.status)">
          {{ value.status.label }}
        </strong>.
      </p>
      <p>
        <template v-if="value.status.maxDays">
          La richiesta dovrebbe rimanere in questo stato per non più di
          <strong>{{ value.status.maxDays }}</strong> giorni.
        </template>
        <template v-else>
          Non è previsto un numero massimo di giorni in cui la richiesta
          possa rimanere in questo stato.
        </template>
      </p>
      <p>
        <template v-if="value.status.primaryActor.length > 1">
          Gli attori che controllano questo stato sono:
        </template>
        <template v-else>
          L'attore che controlla questo stato è:
        </template>
        <ul>
          <template v-for="(t, index) in value.status.primaryActor">
            <li :key="t">
              <strong>{{ actorFor(t) }}</strong>{{ index == value.status.primaryActor.length - 1 ? '.' : ';' }}
            </li>
          </template>
        </ul>
      </p>
      <template v-if="value.status.helpText">
        <h3>Ulteriori informazioni</h3>
        <p>
        {{ value.status.helpText }}
        </p>
      </template>
      <template v-if="outgoingArrows.length">
        <h3>Possibili stati futuri</h3>

        <template v-for="a in orderedOutgoingArrows">
          <div :key="a.toStatus.id">
            <p>
              <strong :class="'text-' + variantFor(a.toStatus)">{{ a.toStatus.label }}</strong>
            </p>
            <div class="pl-4">
              <p>
                Azione da eseguire per portare la richiesta nello stato:
                <strong :class="'text-' + variantFor(a.toStatus)">{{ a.label }}</strong>
              </p>
              <tag-alternatives
                component="p"
                :value="a.toStatus.tagAlternatives"
              />
              <p>
                <template v-if="a.toStatus.primaryActor.length > 1">
                  Attori che controllano lo stato:
                </template>
                <template v-else>
                  Attore che controlla lo stato:
                </template>
                <ul>
                  <template v-for="(t, index) in a.toStatus.primaryActor">
                    <li :key="t">
                      <strong>{{ actorFor(t) }}</strong>{{ index == a.toStatus.primaryActor.length - 1 ? '.' : ';' }}
                    </li>
                  </template>
                </ul>
              </p>
            </div>
          </div>
        </template>
      </template>
    </div>
  </form>
</template>
<script>
import EditorMixin from "vue-template/common/mixins/EditorMixin";
import ErrorCounterMixin from "vue-forms/mixins/ErrorCounterMixin";
import TagAlternatives from '@/protected/components/TagAlternatives';

export default {
  mixins: [EditorMixin, ErrorCounterMixin],

  components: {
    TagAlternatives
  },

  computed: {
    outgoingArrows() {
      const s = this.value && this.value.status;
      if (!s) return [];
      const ret = s.outgoingArrows.map(a => ({
        label: a.label,
        toStatus: this.value.product.statuses.find(n => n.id === a.toStatusId),
      }));
      //console.log('outgoingArrows', ret);
      return ret;
    },

    auspicableNextStatus() {
      return this.outgoingArrows.find(x => x.toStatus.colPosition === 1);
    },

    sideStatus() {
      return this.outgoingArrows.find(x => x.toStatus.colPosition === 2
          && x.toStatus.type === 'INTERMEDIATE');
    },

    failureStatus() {
      return this.outgoingArrows.find(x => x.toStatus.type === 'FAILURE');
    },

    orderedOutgoingArrows() {
      return [
        this.auspicableNextStatus,
        this.sideStatus,
        this.failureStatus
      ].filter(x => x);
    }
  },

  methods: {
    /*
    getOutgoingArrows(s) {
      return s.outgoingArrows.map(a => ({
        label: a.label,
        toStatus: this.value.product.statuses.find(n => n.id === a.toStatusId)
      }));
    },
    */

    variantFor(s) {
      if (s.id === this.auspicableNextStatus.toStatus.id) {
        return 'success';
      }

      switch (s.type) {
        case 'INITIAL':
          return 'info';
        case 'INTERMEDIATE':
          return 'warning';
        case 'SUCCESS':
          return 'success';
        case 'FAILURE':
          return 'danger'
      }
      throw Error("Unsupported type: " + s.type);
    },

    actorFor(s) {
      switch (s) {
        case 'ADMIN':
          return 'l\'amministratore di sistema';
        case 'CUSTOMER':
          return 'il cliente';
        case 'PROVIDER':
          return 'il fornitore';
        case 'BROKER':
          return 'il gestore';
        default:
          throw Error("Unsupported");
      }
    },
  }
};
</script>
